// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  EmailSent as StyledSent,
  VerifiedStatus,
  EmailNotification,
  ResendInfo,
} from "./styles";
import Icon from "src/icons";
import { srwSignUp } from "src/actions/signup";
import { sendVerificationEmail } from "src/actions/auth";
import useKeyDownHandlers from "src/hooks/useKeyDownHandlers";
import { getLocationPayload } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  email: string,
  resumeSignup: boolean /* User signup is pending or not */,
  _srwSignUp: typeof srwSignUp,
};

const EmailSent = ({ email, resumeSignup, _srwSignUp }: Props) => {
  const dispatch = useDispatch();

  const { handleEnter } = useKeyDownHandlers(_srwSignUp);
  const resumeSignupEmail = useSelector(({ location }) =>
    getLocationPayload("email")(location),
  ); /* Get the user email whose sign up is pending from the payload */

  const handleClick = () => {
    if (resumeSignup) {
      dispatch(
        sendVerificationEmail({
          email: resumeSignupEmail,
          resendEmailInvite: true,
        }),
      );
    } else {
      _srwSignUp();
    }
  };

  return (
    <StyledSent>
      <VerifiedStatus>
        <Icon type="verificationSent" />
        {i18n.t(k.VERIFICATION_EMAIL_SENT)}
      </VerifiedStatus>
      <EmailNotification>
        {i18n.t(k.AN_EMAIL_HAS_BEEN_SENT_TO)}{" "}
        <strong>{resumeSignup ? resumeSignupEmail : email}</strong>
        {i18n.t(k.PLEASE_OPEN_YOUR_EMA)}
      </EmailNotification>
      <ResendInfo>
        {i18n.t(k.CLICK_HERE_TO)}{" "}
        <span
          role="button"
          tabIndex="0"
          onClick={handleClick}
          onKeyDown={handleEnter}
        >
          {i18n.t(k.RESEND1)}
        </span>
      </ResendInfo>
    </StyledSent>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  email: app.srw.query.email,
});

export default connect(mapStateToProps, {
  _srwSignUp: srwSignUp,
})(EmailSent);
